import { Link } from 'react-router-dom';
import { SHORTCUTS } from '@/lib/book';

export default function ShortcutGrid() {
  return (
    <section className="w-full bg-background-50">
      <div className="mx-auto w-full px-4 py-14 md:px-10 md:py-20">
        <div className="mb-8 md:mb-10">
          <p className="font-label text-sm font-medium tracking-[0.2em] text-accent-700">바로가기</p>
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            궁금한 곳으로 곧장 펼쳐 보기
          </h2>
          <p className="mt-3 max-w-2xl text-sm leading-relaxed text-secondary-600 md:text-base">
            보고 싶은 부분을 누르면 그 쪽으로 바로 이동합니다. 차례를 거치지 않아도 됩니다.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:gap-5 lg:grid-cols-3">
          {SHORTCUTS.map((item) => (
            <Link
              key={item.page}
              to={`/read?page=${item.page}`}
              className="group flex flex-col rounded-lg border border-background-300 bg-background-100 p-5 transition-colors hover:border-accent-400 md:p-6"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-100 text-accent-800">
                <i className={`${item.icon} text-xl`} aria-hidden="true"></i>
              </span>
              <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{item.title}</h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-secondary-600">{item.desc}</p>
              <span className="mt-4 flex items-center gap-1 font-label text-sm font-medium text-accent-700">
                {item.page}쪽부터
                <i className="ri-arrow-right-line text-base transition-transform group-hover:translate-x-1" aria-hidden="true"></i>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}